import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined';
import { Link as LinkDeRota, useParams } from 'react-router-dom';

import { PainelDeParametrizacao } from './PainelDeParametrizacao';

/**
 * Parametrização de um contrato (`TP-051`, T10/T11) — rota de detalhe,
 * alcançada pelo botão da tela de Contratos (fora do menu, mesmo padrão de
 * `/contratos/fontes/:fonteId/revisao`, `DI31` do TP-050).
 */
export function PaginaDeParametrizacao(): React.JSX.Element {
  const { contratoId } = useParams<{ contratoId: string }>();

  if (contratoId === undefined) {
    return (
      <Alert severity="error" role="alert">
        Contrato não informado na rota.
      </Alert>
    );
  }

  return (
    <>
      <Button component={LinkDeRota} to="/contratos" startIcon={<ArrowBackOutlined />} sx={{ alignSelf: 'start', mb: 2 }}>
        Voltar para Contratos
      </Button>
      <PainelDeParametrizacao contratoId={contratoId} />
    </>
  );
}
